import type { SelectOption } from '../Select';

export const tableLimitSelectDefaultOptions: SelectOption[] = [
  { label: '5개씩 보기', value: '5' },
  { label: '10개씩 보기', value: '10' },
  { label: '30개씩 보기', value: '30' },
  { label: '50개씩 보기', value: '50' },
];
